import { Button, Input } from "@newsela/angelou";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import globalToasterRef from "@/base/globalToasterRef";
import usePasswordResetEmail from "@/users/usePasswordResetEmail/usePasswordResetEmail";
import {
  containerCss,
  formCss,
  headerCss,
  noteCss,
  separatorCss,
} from "./PasswordResetPage.style";
import { EVENT_TOAST_ERROR } from "./PasswordResetPage.utils";

const PasswordResetPage = () => {
  const router = useRouter();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const [sendPasswordResetEmail, { loading }] = usePasswordResetEmail();

  const onSubmit = async (form) => {
    const response = await sendPasswordResetEmail(form);
    if (response.error) {
      try {
        const { error } = JSON.parse(response.error.toJSON().message);
        globalToasterRef.current.displayToast({
          ...EVENT_TOAST_ERROR,
          children: error,
        });
      } catch {
        globalToasterRef.current.displayToast(EVENT_TOAST_ERROR);
      }
    } else {
      router.replace({ pathname: "/signin/password-reset-sent/", query: form });
    }
  };

  return (
    <div css={containerCss}>
      <div css={headerCss}>
        <h1>Reset Password</h1>
        <p>
          Enter your email address and we'll send you your username and
          instructions for creating a new password.
        </p>
      </div>
      <form css={formCss} onSubmit={handleSubmit(onSubmit)}>
        <Input
          label="Email"
          inputType={Input.inputTypes.email}
          error={errors?.email?.message}
          touched
          {...register("email", { required: "This field is required." })}
        />
        <Button type="submit" disabled={loading}>
          Send
        </Button>
      </form>
      <hr css={separatorCss} />
      <div css={noteCss}>
        <strong>Note to students</strong>
        <p>
          Most student accounts are created with a username and no email. If you
          have forgotten your username or password, please ask your teacher or
          other adult for help.
        </p>
      </div>
    </div>
  );
};

export default PasswordResetPage;
